//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../../store/store';
import { useNav } from '../../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import fries from '../../../assets/images/fries.webp';
import cn from 'classnames';

const CORRECT_ANSWER = '390 kcal';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const [incorrectAnswer, setIncorrectAnswer] = useState<string | null>(null);
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  const [isCorrectSelected, setIsCorrectSelected] = useState(false);
  const [hasNavigated, setHasNavigated] = useState(false);

useEffect(() => {
  if (hasNavigated) return;

  if (isCorrectSelected) {
    const timer = setTimeout(() => {
      setHasNavigated(true);
      onNext();
    }, 800);
    return () => clearTimeout(timer);
  }

  if (incorrectAnswer && showCorrectAnswer) {
    const timer = setTimeout(() => {
      setHasNavigated(true);
      onNext();
    }, 1000);
    return () => clearTimeout(timer);
  }
}, [isCorrectSelected, incorrectAnswer, showCorrectAnswer, onNext, hasNavigated]);

  const handleAnswer = (value: string) => {
    setIncorrectAnswer(null);
    setShowCorrectAnswer(false);
    setIsCorrectSelected(false);

    if (value !== CORRECT_ANSWER) {
      setIncorrectAnswer(value);
      setTimeout(() => setShowCorrectAnswer(true), 600);
      return;
    }

    setIsCorrectSelected(true);
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: 'how-many-calories-7',
      answer: value,
    });
  };

  const options = [
    { value: '120 kcal' },
    { value: '270 kcal' },
    { value: CORRECT_ANSWER },
    { value: '515 kcal' },
  ];

  return (
    <div className='page' style={{ gap: 0 }}>
      <div className='wrapper-info'>
        <Title tag='h2' style={{ padding: '0 30px' }}>
          {t('onboarding.howManyCalories.title')}
        </Title>
        <Text className='description' size='m' medium style={{ padding: 0 }}>
          {t('onboarding.howManyCalories.dishes.fries')}
        </Text>
        <img src={fries} width={308} alt='Portion of fries' />
      </div>

      <div className='controls'>
        <Check onChange={handleAnswer}>
          {options.map((option) => (
            <Option
              key={option.value}
              value={option.value}
              className={cn({
                'incorrect-answer': incorrectAnswer === option.value,
                'correct-answer':
                  (showCorrectAnswer || isCorrectSelected) && option.value === CORRECT_ANSWER,
              })}
            >
              {option.value}
            </Option>
          ))}
        </Check>
      </div>
    </div>
  );
}

export default Page;
